import { createPortal } from 'react-dom'

import LocationSelectionMapModal from 'Presentation/Components/LocationSelectionMapModal/View'
import { Modal } from 'react-bootstrap'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import Select from 'react-select'

import useViewModel from './ViewModel'

const FormShippingModal: React.FC = () => {
	const {
		formState,
		formType,
		handleClose,
		handleSubmit,
		onChange,
		open,
		onSelectMapLocation,
		isLoadingProvinces,
		isLoadingAmphures,
		isLoadingTumbons,
		provinces,
		amphures,
		tumbons,
		zipCode,
		errors,
		isSubmitting,
	} = useViewModel()
	const modalsRoot = document.getElementById('root-modals') || document.body

	return createPortal(
		<Modal
			size="sm"
			id="kt_modal_supplier_shipping_address_modal"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-dialog modal-dialog-centered mw-600px"
			show={open}
			onHide={handleClose}
			backdrop={isSubmitting ? 'static' : true}>
			<LocationSelectionMapModal />

			<div className="modal-content">
				<div className="modal-body py-lg-10 px-lg-10 min-h-500px">
					<h1 className="text-kumopack-grey-900 text-center">
						{formType === 'add' ? 'เพิ่มที่อยู่ในการจัดส่งสินค้า' : 'แก้ไขที่อยู่ในการจัดส่งสินค้า'}
					</h1>
					{/* <div className="text-kumupack-grey-600 text-center">
						ทุกความคิดเห็นของท่านมีผลต่อการปรับปรุงระบบให้ดีิยิ่งขึ้น
					</div> */}

					<div className="mt-10 card border border-kumopack-grey-200">
						<div className="card-body">
							<FormGenerator
								formKey="title"
								inputType="plain"
								label="ชื่อเรียกที่อยู่"
								additionalLabelCom={<span className="required"></span>}
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.title}
								onChange={e => onChange('title', e.target.value)}
								isShowValid={errors.title}
								additionalComInput={
									errors.title ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.title}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="receiverFullname"
								inputType="plain"
								label="ชื่อนามสกุลผู้รับ"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.receiverFullname}
								onChange={e => onChange('receiverFullname', e.target.value)}
								isShowValid={errors.receiverFullname}
								additionalComInput={
									errors.receiverFullname ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.receiverFullname}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="receiverPhone"
								inputType="plain"
								label="หมายเลขโทรศัพท์ผู้รับ"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								value={formState.receiverPhone}
								onChange={e => onChange('receiverPhone', e.target.value)}
								markInput
								mark="999-999-9999"
								markChar={null}
								isShowValid={errors.receiverPhone}
								additionalComInput={
									errors.receiverPhone ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.receiverPhone}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="latitude-and-longitude"
								value={`${formState.latitude}, ${formState.longitude}`}
								inputType="plain"
								label="ละติจูด, ลองจิจูด"
								additionalClassName="form-control-sm"
								additionalLabelCom={<span className="required" />}
								additionalComInput={
									<button
										className="mt-5 btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white"
										onClick={onSelectMapLocation}>
										คลิกเพื่อเลือกจากแผนที่
									</button>
								}
								placeholder="13.7563, 100.5018"
								containerClassName="mb-5"
								isHorizontal={false}
								disabled
							/>

							<FormGenerator
								formKey="address"
								inputType="textarea"
								label="ที่อยู่โดยละเอียด"
								additionalClassName="form-control-sm"
								containerClassName="mb-5"
								isHorizontal={false}
								limitCharacter={100}
								value={formState.address}
								onChange={e => onChange('address', e.target.value)}
								isShowValid={errors.address}
								additionalComInput={
									errors.address ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.address}</div>
										</div>
									) : undefined
								}
							/>

							<div className="row mb-5">
								<div className="col-12 col-xl-6">
									<label className="text-gray-700 fw-bold mb-1">
										จังหวัด <span className="required"></span>
									</label>
									<Select
										isLoading={isLoadingProvinces}
										isClearable
										isSearchable
										isMulti={false}
										options={provinces}
										placeholder="กรุณาเลือก"
										value={provinces.find(p => p.value === formState.provinceId) ?? null}
										onChange={val => onChange('provinceId', val?.value)}
										styles={{
											control: baseStyles => ({
												...baseStyles,
												border: errors.provinceId ? '1px solid #f1416c' : '1px solid #e1e3ea',
											}),
										}}
									/>

									{errors.provinceId && (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.provinceId}</div>
										</div>
									)}
								</div>
								<div className="col-12 col-xl-6">
									<label className="text-gray-700 fw-bold mb-1">
										เขต / อำเภอ <span className="required"></span>
									</label>
									<Select
										isLoading={isLoadingAmphures}
										isClearable
										isSearchable
										isMulti={false}
										options={amphures}
										placeholder='กรุณาเลือก "จังหวัด" ก่อน'
										value={amphures.find(z => z.value === formState.amphureId) ?? null}
										onChange={val => onChange('amphureId', val?.value)}
										styles={{
											control: baseStyles => ({
												...baseStyles,
												border: errors.amphureId ? '1px solid #f1416c' : '1px solid #e1e3ea',
											}),
										}}
									/>

									{errors.amphureId && (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.amphureId}</div>
										</div>
									)}
								</div>
							</div>

							<div className="row">
								<div className="col-12 col-xl-6">
									<label className="text-gray-700 fw-bold mb-1">
										แขวง / ตำบล <span className="required"></span>
									</label>
									<Select
										isLoading={isLoadingTumbons}
										isClearable
										isSearchable
										isMulti={false}
										options={tumbons}
										placeholder='กรุณาเลือก "อำเภอ" ก่อน'
										value={tumbons.find(p => p.value === formState.tumbonId) ?? null}
										onChange={val => onChange('tumbonId', val?.value)}
										styles={{
											control: baseStyles => ({
												...baseStyles,
												border: errors.tumbonId ? '1px solid #f1416c' : '1px solid #e1e3ea',
											}),
										}}
									/>

									{errors.tumbonId && (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{errors.tumbonId}</div>
										</div>
									)}
								</div>
								<div className="col-12 col-xl-6">
									<label className="text-gray-700 fw-bold mb-1">
										รหัสไปรษณีย์ <span className="required"></span>
									</label>
									<FormGenerator
										formKey="zipcode"
										inputType="plain"
										disabled
										additionalClassName="form-control-sm"
										containerClassName="mb-5"
										value={zipCode ?? ''}
										placeholder='กรุณาเลือก "แขวง / ตำบล" ก่อน'
									/>
								</div>
							</div>
						</div>

						<div className="card-footer">
							<div className="row">
								<div className="col-12 col-xl-6">
									<button
										disabled={isSubmitting}
										className="btn btn-sm white-button text-kumopack-grey-700 fw-bold w-100"
										onClick={handleClose}>
										ยกเลิก
									</button>
								</div>
								<div className="col-12 col-xl-6">
									<button
										disabled={isSubmitting}
										className="btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold w-100"
										onClick={handleSubmit}>
										{!isSubmitting ? 'บันทึก' : 'กำลังบันทึก'}{' '}
										<img src="/media/icons/kumopack/chevron-right.svg" alt="White Chevron Right" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>,
		modalsRoot
	)
}

export default FormShippingModal
